import { Component } from '@angular/core';

@Component({
  selector: 'app-policies',
  imports: [],
  templateUrl: './policies.component.html',
  styleUrl: './policies.component.scss',
})
export class PoliciesComponent {}
